import { Switch, Route, Redirect, useRouteMatch } from 'peach/router'

import APIKey from './APIKey'
import APIKeys from './APIKeys'
import CreateAPIKey from './CreateAPIKey'

const APIKeysRoutes = () => {
  const { path, url } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={path}>
        <APIKeys />
      </Route>

      <Route path={`${path}/create`}>
        <CreateAPIKey />
      </Route>

      <Route path={`${path}/:apiKeyId`}>
        <APIKey />
      </Route>

      <Redirect to={url} />
    </Switch>
  )
}

export default APIKeysRoutes
